var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M1 2C1 1.50033 1.00212 1.22617 1.02769 1.03598C1.02803 1.0335 1.02836 1.03107 1.02869 1.02869C1.03107 1.02836 1.0335 1.02803 1.03598 1.02769C1.22617 1.00212 1.50033 1 2 1H16C16.4997 1 16.7738 1.00212 16.964 1.02769C16.9665 1.02803 16.9689 1.02836 16.9713 1.02869C16.9716 1.03107 16.972 1.0335 16.9723 1.03598C16.9979 1.22617 17 1.50033 17 2V4C17 4.49967 16.9979 4.77383 16.9723 4.96402C16.972 4.9665 16.9716 4.96893 16.9713 4.97131C16.9689 4.97164 16.9665 4.97197 16.964 4.97231C16.7738 4.99788 16.4997 5 16 5H2C1.50033 5 1.22617 4.99788 1.03598 4.97231C1.0335 4.97197 1.03107 4.97164 1.02869 4.97131C1.02836 4.96893 1.02803 4.9665 1.02769 4.96402C1.00212 4.77383 1 4.49967 1 4V2Z",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 9C0 8.44772 0.447715 8 1 8H17C17.5523 8 18 8.44772 18 9C18 9.55228 17.5523 10 17 10H1C0.447716 10 0 9.55228 0 9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 13C9 12.4477 9.44772 12 10 12H17C17.5523 12 18 12.4477 18 13C18 13.5523 17.5523 14 17 14H10C9.44772 14 9 13.5523 9 13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 13C0 12.4477 0.447715 12 1 12H6C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H1C0.447715 14 0 13.5523 0 13Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 17C0 16.4477 0.447715 16 1 16H17C17.5523 16 18 16.4477 18 17C18 17.5523 17.5523 18 17 18H1C0.447716 18 0 17.5523 0 17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.ed6f06d478ce78546878938f96812a61.svg";
export { ForwardRef as ReactComponent };